import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getCartItemsFromCookie, setCartItemsToCookie } from '../helpers/helperFunctions';
import { ICartItems } from '../types/GlobalInterfaces';

export interface AppState {
    totalItems: number;
    cartItems: ICartItems[];
    subTotal: number;
    total: number;
};

const initialState: AppState = {
    totalItems: 0,
    cartItems: [],
    subTotal: 0,
    total: 0,
};

// const initializeCart = () => {
//     try {
//         const arr = getCartItemsFromCookie();
//         initialState.totalItems = arr.length || 0;
//         initialState.cartItems = arr;
//         initialState.subTotal = arr.reduce((total, item) => total + (item.regularPrice || 0), 0);
//         initialState.total = arr.reduce((total, item) => total + (item.salePrice || item.regularPrice || 0), 0);
//     } catch (error) {
//         console.warn('Failed to initialize cart from cookie:', error);
//     }
// };

// initializeCart();

export const Cart = createSlice({
    name: 'CART_SLICE',
    initialState,
    reducers: {
        addItemToCart: (state, action: PayloadAction<ICartItems>) => {
            const newItem = action.payload;

            const isExist = state.cartItems.some(item => item._id === newItem._id);

            if (!isExist) {
                const newCartItems = [...state.cartItems, newItem];
                state.totalItems = newCartItems?.length || 0;
                state.cartItems = newCartItems;

                state.subTotal = newCartItems.reduce((total, item) => total + (item.regularPrice || 0), 0);
                state.total = newCartItems.reduce((total, item) => total + (item.salePrice || item.regularPrice || 0), 0);

                // setCartItemsToCookie(newCartItems);
            }
        },
        setCartItems : (state , action : PayloadAction<ICartItems[]>) => {
            const items = action.payload;
            state.cartItems = [...state.cartItems, ...items];
        },
        updateCartQuantity: (state, action: PayloadAction<{ productId: string; quantity: number }>) => {
            const { productId, quantity } = action.payload;
            const item = state.cartItems.find(item => item.productId === productId);
            if (item) {
                item.quantity = quantity;
            }
        },
        removeItemFromCart: (state, action: PayloadAction<string[]>) => {
            const newCartItems = state.cartItems.filter(item => !action.payload.includes(item.productId));
            state.totalItems = newCartItems.length || 0;
            state.cartItems = newCartItems;

            state.subTotal = newCartItems.reduce((total, item) => total + (item.regularPrice || 0), 0);
            state.total = newCartItems.reduce((total, item) => total + (item.salePrice || item.regularPrice || 0), 0);

            // setCartItemsToCookie(newCartItems);
        },
        cartEmpty: (state) => {
            state.totalItems = 0;
            state.cartItems = [];
            state.subTotal = 0;
            state.total = 0;
            // setCartItemsToCookie([]);
        },
    }
});

// Export action creators
export const { addItemToCart, removeItemFromCart, cartEmpty , setCartItems, updateCartQuantity } = Cart.actions;

// Export the reducer to be used in the store
export default Cart.reducer;